export class AlternativeDetailsDialogViewModel
{
    opened: boolean = false;
    
    name: string | null = null;
    description: string | null = null;
    detailsUrl: string | null = null;

    show(name: string, description: string, detailsUrl: string | null = null)
    {
        this.name = name;
        this.description = description;
        this.detailsUrl = detailsUrl;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.name = null;
        this.description = null;
        this.detailsUrl = null;
    }
}